var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"products"},_vm._l((_vm.productNames),function(name,index){return _c('div',{key:name + index,staticClass:"products__product"},[_c('app-product',{attrs:{"product-name":name,"image-lazy":""}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }